import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Client } from '../model/client';

@Injectable({
    providedIn: 'root'
  })
  export class ClientService{
  
    constructor(private _restClientService : RestClientService) { }


    getClientsByRequestId(requestId){
        return this._restClientService.load<Client[]>('client/clients-by-requestId?requestId='+requestId);
    }
  
    getClientById(clientId){
        return this._restClientService.load<Client>('client/client-by-id/'+clientId);
    }

    addClient(client) {
        return  this._restClientService.save<Client>('client/add-client', client);
    }
  
    updateClient(client) {
        return  this._restClientService.put<Client>(`client/update-client`, client);
    }
    
    delete(id) 
    {
        return this._restClientService.delete<any>('client/delete-client/'+id);
    }

    addListClient(clientList) {
        return  this._restClientService.save<Client>('client/add-client-list', clientList);
    }

}      

    